import { application } from "../javascript/controllers/application";
import "./truendo/lifecycle";

import PlaylistController from "./playlist/controller";
import PlaylistItemController from "./playlist_item/controller";
import FloatingSearchController from "./floating_search/controller";
import VideoPlayerController from "./video_player/controller";
import SearchFormController from "./search_form/controller";
import JobFilterController from "./job_filter/controller";
import NavSearchController from "./nav_search/controller";
import MomentCardController from "./moment_card/controller";
import MomentReelController from "./moment_reel/controller";
import ShareLinkController from "./share_link/controller";
import MarkdownActionController from "./markdown_action/controller";
import ThemeSwitcherController from "./theme_switcher/controller";
import KeyboardHintController from "./keyboard_hint/controller";
import SeasonalThemeToggleController from "./seasonal_theme_toggle/controller";
import SpeakerFilterController from "./speaker_filter/controller";
import FilterChipsController from "./filter_chips/controller";
import TurnstileController from "./turnstile/controller";
import TruendoController from "./truendo/controller";
import SocialContentGateController from "./social_content_gate/controller";
import YoutubeEmbedController from "./youtube_embed/controller";
import GatedVideoPlayerController from "./gated_video_player/controller";

application.register("playlist", PlaylistController);
application.register("playlist-item", PlaylistItemController); 
application.register("floating-search", FloatingSearchController);

application.register("video-player", VideoPlayerController);
application.register("search-form", SearchFormController);
application.register("job-filter", JobFilterController);
application.register("nav-search", NavSearchController);
application.register("moment-card", MomentCardController);
application.register("moment-reel", MomentReelController);
application.register("share-link", ShareLinkController);
application.register("markdown-action", MarkdownActionController);
application.register("theme-switcher", ThemeSwitcherController);
application.register("keyboard-hint", KeyboardHintController);
application.register("seasonal-theme-toggle", SeasonalThemeToggleController);
application.register("speaker-filter", SpeakerFilterController);
application.register("filter-chips", FilterChipsController);
application.register("turnstile", TurnstileController);
application.register("truendo", TruendoController);
application.register("social-content-gate", SocialContentGateController);
application.register("youtube-embed", YoutubeEmbedController);
application.register("gated-video-player", GatedVideoPlayerController);
